import { render, staticRenderFns } from "./exchangeHouses.vue?vue&type=template&id=5cea12cc&scoped=true&"
import script from "./exchangeHouses.vue?vue&type=script&lang=js&"
export * from "./exchangeHouses.vue?vue&type=script&lang=js&"
import style0 from "./exchangeHouses.vue?vue&type=style&index=0&id=5cea12cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cea12cc",
  null
  
)

export default component.exports